export const typeList = [
  {
    code: 0,
    displayName: '单选题',
  },
  {
    code: 1,
    displayName: '多选题',
  },
  {
    code: 2,
    displayName: '判断题',
  },
  {
    code: 3,
    displayName: '填空题',
  },
  {
    code: 4,
    displayName: '简答题',
  },
]

export const answerList = [
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
]

export const doubleAnswerList = [
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
  {
    checked: false,
    content: '',
  },
]

export const singleAnswerList = [
  {
    checked: false,
    content: '正确',
  },
  {
    checked: false,
    content: '错误',
  },
]

export function formatSeconds(s) {
  let hours = Math.floor(s / 3600)
  hours = hours < 10 ? `0${hours}` : hours
  let minutes = Math.floor((s % 3600) / 60)
  minutes = minutes < 10 ? `0${minutes}` : minutes
  let seconds = s % 60
  seconds = seconds < 10 ? `0${seconds}` : seconds
  return `${hours}:${minutes}:${seconds}`
}
